import { useColorModeValue } from '@chakra-ui/react';

/** Shared marketing-home palette aligned with theme semantic tokens. */
export function useHomePageColors() {
  return {
    surfaceMuted: useColorModeValue('#F6F7F9', 'gray.700'),
    surfaceCard: useColorModeValue('white', 'gray.600'),
    surfaceInset: useColorModeValue('#e2e3e5', 'gray.600'),
    brandAccent: useColorModeValue('#27ADE4', '#19C8F5'),
    heading: useColorModeValue('black', 'white'),
    body: useColorModeValue('gray.700', 'gray.200'),
    bodyMuted: useColorModeValue('gray.600', 'gray.400'),
    border: useColorModeValue('blackAlpha.200', 'whiteAlpha.300'),
    borderStrong: useColorModeValue('#232323', 'whiteAlpha.400'),
    divider: useColorModeValue('gray.400', 'gray.500'),
    onAccent: 'white',
    trendSame: useColorModeValue('black', 'white'),
  };
}
